import { render, staticRenderFns } from "./WishItem.vue?vue&type=template&id=04295678"
import script from "./WishItem.vue?vue&type=script&lang=js"
export * from "./WishItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports